import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import { Tag, Button } from 'antd';
import { ScanButtonType } from '@components/aiAlerts/AlertsConfig/alertConfig.types';

export const HeaderWrapper = styled.div`
  padding: 20px 0;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  flex-wrap: wrap;
  width: 100%;
  box-sizing: border-box;
`;

export const LeftWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  column-gap: 20px;
  order: 1;
  ${breakpoint('tablet')`
        width: 50%;
    `};

  ${breakpoint('desktop')`
        width: 50%;
    `};

  ${breakpoint('mobile')`
        width: 100%;
    `};
`;

export const RightWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  order: 1;
  flex-wrap: wrap;
  align-items: flex-end;
  align-items: center;
  gap: 5px;
  ${breakpoint('tablet')`
        width: 50%;
    `};

  ${breakpoint('desktop')`
        width: 50%;
    `};

  ${breakpoint('mobile')`
        width: 100%;
    `};
`;

export const SearchWrapper = styled.div`
  width: 50%;
`;

export const DateWrapper = styled.div`
  ${breakpoint('tablet')`
        padding-top: 5px;
    `};
  ${breakpoint('desktop')`
        padding-top: 0px;
    `};
  ${breakpoint('mobile')`
        padding-top: 5px;
    `};
  order: 1;
`;

export const Title = styled.div`
  font-size: 28px;
  font-weight: 400;
  line-height: 36px;
  letter-spacing: 0;
  text-align: left;
  color: #000;
`;

export const StyledButton = styled(Button)`
  min-height: 33px;
`;

export const StyledTag = styled(Tag)`
  height: 32px;
  margin-left: 10px;
  position: relative;
  padding-right: 25px;
  line-height: 2.5;

  .anticon {
    position: absolute;
    top: 50%;
    right: 5%;
    transform: translateY(-50%);
  }
`;

export const InsightsBtn = styled(Button)`
  margin: 0 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 5px;
  color: #0046ff;
  border-color: #0046ff;
  border-radius: 4px;

  &:hover {
    color: #0046ff;
    border-color: #0046ff;
  }
`;

export const IconWrap = styled.div`
  font-size: 1.25em;
  line-height: 0;
  margin-right: 3px;
  display: inline-block;
  fill: #0046ff;
  vertical-align: -0.125em;
`;

export const ScanIconWrap = styled.div`
  display: flex;
  align-items: center;
  column-gap: 7px;
  font-size: 25px;
`;

export const CombinationText = styled.p<ScanButtonType>`
  display: flex;
  align-items: center;
  column-gap: 5px;
  margin: 0;
  color: ${({ isLink }) => (isLink ? '#0046FF' : '#4A4A4A')};
  font-weight: 500;
  font-size: 15.4px;
  line-height: 21px;
  cursor: ${({ isLoading, isError, isLink }) =>
    isLoading ? 'progress' : isError ? 'not-allowed' : isLink ? 'pointer' : 'inherit'};
`;
